export const environment = {
  production: true,
  auth_client_id: 'stepidbclientid',
  auth_client_secret: 'SJAdajsdjaisASDlkadjahalksjhcjkashd',
  issuer: 'https://step-idb.nl',
  auth_server_url: 'https://step-idb.nl/oauth2/token',
  auth_server_token_check_url: 'https://step-idb.nl/oauth2/check_token',

  api_base_url: 'https://step-idb.nl/api'
};
